export default __webpack_public_path__ + "static/media/pioneer.be16710b.png";